var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ModalFooter, ModalHeader, SlideInModalPortal, } from "syf-component-library/ui/patterns/SlideInModalPortal";
import StatementsModalContent from "./StatementsModalContent";
import FakeOverlay from "./subComponents";
import { useAccountSummary } from "../../../const/syfApiQueries";
import { useStatementsContext } from "../../../context/statementsContext";
import ErrorBoundary from "../ErrorBoundary";
export var statementDetailsModalId = "statements-details-modal";
var StatementsModal = function (_a) {
    var containerId = _a.containerId;
    var headerRef = useRef(null);
    var _b = useStatementsContext(), dispatch = _b.dispatch, _c = _b.state, isModalOpen = _c.isModalOpen, accountId = _c.accountId, isMutationLoading = _c.isMutationLoading, handleClose = _b.handleClose;
    var accountSummary = useAccountSummary(accountId).data;
    var t = useTranslation().t;
    var shouldRenderStatementsModalContent = isModalOpen && accountId && accountSummary;
    var handleCloseFunction = function () {
        if (!isMutationLoading) {
            handleClose();
        }
        dispatch({ showEnrollmentError: false });
    };
    return (_jsxs(_Fragment, { children: [_jsx(SlideInModalPortal, __assign({ id: statementDetailsModalId, containerId: containerId, isOpen: isModalOpen, "aria-labelledby": "Modal Title", escapeModalHandler: handleCloseFunction, header: _jsx(ModalHeader, { headerRef: headerRef, hideClose: true, closeModal: handleCloseFunction, content: t("modal.header.text") }), footer: _jsx(ModalFooter, { handlePrimaryButton: handleCloseFunction, dataPrimaryType: "statements", dataPrimaryReason: "close", dataPrimaryObject: "button", primaryText: t("modal.footer.closeButton"), isPrimaryDisabled: isMutationLoading }) }, { children: shouldRenderStatementsModalContent && (_jsx(ErrorBoundary, { children: _jsx(StatementsModalContent, {}) })) })), isModalOpen && (_jsx(FakeOverlay, { id: "fake-overlay", onClick: handleCloseFunction, "data-type": "statements", "data-reason": "close", "data-analytics": "clicktrackingevent", "aria-hidden": "true" }))] }));
};
export default StatementsModal;
